export const hideSpinnerByRequest = {
    "/quote-editor/premium": "POST",
    "/billing/document": "POST"
}